import React, {Component} from 'react';

import Anime from '../../components/Anime/Anime';

const Title = props => {

	if ( props.title && props.title !== '') {
		return <h1 className="content-header__title">{props.title}</h1>
	} else {
		return null;
	}

};

const SubTitle = props => {

	if ( props.title && props.title !== '') {
		return <h2 className="content-header__subtitle">{props.title}</h2>
	} else {
		return null;
	}

};

class ContentHeader extends Component {

    render () {

        return (
         
            <div className={ `content-header mb mb-sm ${this.props.classes}` }>
            <Anime type="fade-up" delay="0" duration="4">
            	<Title title={this.props.title} />
            </Anime>
            <Anime type="fade-up" delay="2" duration="4">
                <SubTitle title={this.props.subTitle} />
            </Anime>
            </div>

        );
    }
}

export default ContentHeader;


// WEBPACK FOOTER //
// ./src/containers/ContentHeader/ContentHeader.js